import React from 'react';
import './Legal.css';

const CopyrightPolicy: React.FC = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Copyright &amp; Intellectual Property Policy</h1>
      <p className="legal-updated">Last updated: August 26, 2026</p>

      <p>
        PHI Printing respects the intellectual property rights of artists,
        photographers, and creators, and we require everyone who uses the site
        to do the same.
      </p>

      <h2>Customer uploads</h2>
      <p>
        Our custom print service reproduces images that customers upload. Before
        an order is accepted you must confirm that you own the image or have
        permission from the rights holder to have it printed. Examples of images
        you may <strong>not</strong> upload without permission:
      </p>
      <ul>
        <li>Professional photographs (wedding, portrait, school photos) without the photographer's permission</li>
        <li>Artwork, illustrations, or characters owned by someone else</li>
        <li>Images downloaded from the internet, social media, or stock sites without a print license</li>
      </ul>
      <p>
        We may refuse, cancel, and refund any order that we reasonably believe
        infringes someone else's rights, and repeated violations will result in
        account termination.
      </p>

      <h2>Artist uploads</h2>
      <p>
        Artist members confirm that every artwork they upload is their own
        original work, or that they hold sufficient rights to reproduce and sell
        it. Artists retain full ownership of their work; listing artwork on PHI
        Printing grants us only the license needed to display it on the site and
        produce the prints customers order.
      </p>

      <h2>Reporting infringement (DMCA notice)</h2>
      <p>
        If you believe content on this site infringes your copyright, send a
        notice to{' '}
        <a href="mailto:copyright@phiprinting.com">copyright@phiprinting.com</a>{' '}
        including:
      </p>
      <ul>
        <li>Identification of the copyrighted work you claim is infringed</li>
        <li>The URL or description of the infringing material on our site</li>
        <li>Your name, address, email, and telephone number</li>
        <li>A statement that you have a good-faith belief the use is not authorized</li>
        <li>A statement, under penalty of perjury, that the information is accurate and you are the rights holder or authorized to act for them</li>
        <li>Your physical or electronic signature</li>
      </ul>
      <p>
        We will remove or disable access to the identified material promptly
        and notify the user who posted it.
      </p>

      <h2>Counter-notice</h2>
      <p>
        If your content was removed and you believe the removal was a mistake,
        you may send a counter-notice to the same address including the removed
        material's location, your contact details, a statement under penalty of
        perjury that you believe the removal was a mistake or misidentification,
        and your consent to the jurisdiction of your local federal district
        court. We may restore the material after 10–14 business days unless the
        original claimant files a court action.
      </p>

      <h2>Repeat infringers</h2>
      <p>
        Accounts that repeatedly upload infringing content will be terminated.
      </p>
    </div>
  </div>
);

export default CopyrightPolicy;
